<template>
  <div class="c-header-title">
    <h1>{{title}}</h1>
  </div>
</template>
<script>
export default {
  name: 'HeaderTitle',
  props: {
    title: String
  }
}
</script>
<style lang="scss">
  .c-header-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    // height: 70px;
    h1{
      font-weight: 500;
      font-size: 1.8rem;
      line-height: 2rem;
      padding: 1rem 0 1rem 0;
      @media(max-width: 480px){
        font-size: 1.5rem;
      }
    }
  }
</style>
